export default __webpack_public_path__ + "static/media/me.ac2a6a12.png";